import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';

interface MentenancePlanningState {
  id?: any;
  number?: any;
  status?: any;
  statusId?: any;
  company?: any;
  companyId?: any;
  contract?: any;
  contractId?: any;
  workPlace?: any;
  workPlaceId?: any;
  interventionFile?: any;
  interventionFileId?: any;
  mentenancePlanningSystemTypes?: any;
  registeredByUserId?: any;
  registeredByUser?: any;
  assignedTechnician?: any;
  assignedTechnicianId?: any;
  finalDate?: any;
  periodicity?: any;
  lastMentenance?: any;
  dateEnd?: any;
  appointment?: any;
  intervalTimetable?: any;
  history?: any;
  assignedTechnicianDropdown?: any;
  intervalTimetableDropdown?: any;
  appointmentDropdown?: any;
  propsAll: {
    [key: string]: any;
  };
  propsScheduled: {
    [key: string]: any;
  };
  propsRescheduled: {
    [key: string]: any;
  };
  propsHistory: {
    [key: string]: any;
  };
  propsReport: {
    [key: string]: any;
  };

  propsMyActiveMentenancePlannigs: {
    [key: string]: any;
  };
  propsMyHistoryMentenancePlannigs: {
    [key: string]: any;
  };
  selectedRecords: any[];
}

const currentDate = moment().format('DD-MM-YYYY');
const currentDateEnd = moment().add(1, 'year').format('DD-MM-YYYY');

const initialState: MentenancePlanningState = {
  id: '',
  number: 0,
  status: null,
  statusId: 1,
  company: null,
  companyId: '',
  contract: null,
  contractId: '',
  workPlace: null,
  workPlaceId: '',
  interventionFile: null,
  interventionFileId: '',
  mentenancePlanningSystemTypes: [],
  assignedTechnician: null,
  assignedTechnicianId: '',
  registeredByUser: '',
  registeredByUserId: null,
  finalDate: currentDate,
  periodicity: '',
  lastMentenance: currentDate,
  dateEnd: currentDateEnd,
  appointment: currentDate,
  intervalTimetable: '',
  history: '',
  assignedTechnicianDropdown: '',
  intervalTimetableDropdown: '',
  appointmentDropdown: currentDate,
  propsAll: { searchTerm: '', skip: 1, take: 10, totalItems: 0, refresh: false, hasMore: true, selectedRecords: [] },
  propsScheduled: { searchTerm: '', skip: 1, take: 10, totalItems: 0, refresh: false, selectedTechnician: null },
  propsRescheduled: { searchTerm: '', skip: 1, take: 10, totalItems: 0, refresh: false, selectedTechnician: null },
  propsHistory: { searchTerm: '', skip: 1, take: 10, totalItems: 0, refresh: false, selectedTechnician: null },
  propsReport: {
    searchTerm: '',
    skip: 1,
    take: 10,
    totalItems: 0,
    refresh: false,
    selectedMonth: null,
    selectedTechnician: null,
    selectedStatus: null,
  },
  propsMyActiveMentenancePlannigs: { searchTerm: '', skip: 1, take: 10, totalItems: 0, refresh: false },
  propsMyHistoryMentenancePlannigs: { searchTerm: '', skip: 1, take: 10, totalItems: 0, refresh: false },
  selectedRecords: [],
};

const MentenancePlanningSlice = createSlice({
  name: 'mentenancePlanning',
  initialState,
  reducers: {
    setMentenancePlanning: (state, action: PayloadAction<Partial<MentenancePlanningState>>) => {
      return { ...state, ...action.payload };
    },
    updateField: (state: any, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    updatePropsAll: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.propsAll = {
        ...state.propsAll,
        [field]: value,
      };
    },
    updatePropsScheduled: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.propsScheduled = {
        ...state.propsScheduled,
        [field]: value,
      };
    },
    updatePropsRescheduled: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.propsRescheduled = {
        ...state.propsRescheduled,
        [field]: value,
      };
    },
    updatePropsHistory: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.propsHistory = {
        ...state.propsHistory,
        [field]: value,
      };
    },
    updatePropsReport: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.propsReport = {
        ...state.propsReport,
        [field]: value,
      };
    },
    updatePropsMyActiveMentenancePlannigs: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.propsMyActiveMentenancePlannigs = {
        ...state.propsMyActiveMentenancePlannigs,
        [field]: value,
      };
    },
    updatePropsMyHistoryMentenancePlannigs: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.propsMyHistoryMentenancePlannigs = {
        ...state.propsMyHistoryMentenancePlannigs,
        [field]: value,
      };
    },
    setSelectedRecords: (state, action: PayloadAction<any[]>) => {
      const updatedRecords = action.payload.map((record: any) => ({
        ...record,
      }));
      state.selectedRecords = updatedRecords;
    },
  },
});

export const {
  setMentenancePlanning,
  updateField,
  updatePropsAll,
  updatePropsHistory,
  updatePropsRescheduled,
  updatePropsScheduled,
  updatePropsReport,
  setSelectedRecords,
  updatePropsMyActiveMentenancePlannigs,
  updatePropsMyHistoryMentenancePlannigs,
} = MentenancePlanningSlice.actions;

export default MentenancePlanningSlice.reducer;
